import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import PageLayout from "./PageLayout";
import { listContent, mediaUrl } from "../lib/api";

export default function BlogPostPage() {
  const { slug } = useParams();
  const [post, setPost] = useState(undefined);

  useEffect(() => {
    window.scrollTo(0, 0);
    listContent("blog")
      .then((posts) => setPost(posts.find((p) => p.slug === slug) || null))
      .catch(() => setPost(null));
  }, [slug]);

  if (post === undefined) {
    return <PageLayout title="Blog"><div className="py-20" /></PageLayout>;
  }
  if (!post) {
    return (
      <PageLayout title="Post Not Found">
        <div className="max-w-2xl mx-auto px-5 py-20 text-center">
          <p className="font-serif-body text-[#666]">
            Sorry, we couldn't find that article.
          </p>
          <Link
            to="/blog"
            className="inline-block mt-6 font-serif-body text-[#0f9fbc] font-bold"
          >
            ← Back to the blog
          </Link>
        </div>
      </PageLayout>
    );
  }

  return (
    <PageLayout title={post.title} subtitle={`${post.author} · ${post.readTime}`}>
      <article className="max-w-3xl mx-auto px-5 py-14 md:py-20">
        <div className="rounded-[12px] overflow-hidden aspect-[16/9] mb-10">
          <img
            src={mediaUrl(post.image)}
            alt={post.title}
            className="w-full h-full object-cover"
          />
        </div>

        <span className="font-serif-body text-[12px] uppercase tracking-wide text-[#68c2d5] font-bold">
          {post.category}
        </span>

        <div className="mt-4 space-y-6">
          {post.body.map((para, i) => (
            <p
              key={i}
              className="font-serif-body text-[#444] text-[17px] leading-[1.9]"
            >
              {para}
            </p>
          ))}
        </div>

        <div className="mt-12 pt-8 border-t border-[#e6eef0]">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 font-serif-body text-[#0f9fbc] font-bold hover:text-[#008da9] transition-colors"
          >
            <ArrowLeft size={18} /> Back to the blog
          </Link>
        </div>
      </article>
    </PageLayout>
  );
}
